import {ApolloError} from "@apollo/client";

import {PdfResult} from "@/lib/types/common.ts";

const BLOB_URL_REVOKE_DELAY_MS = 60_000;
const RATE_LIMIT_MESSAGE = "rate limit exceeded";

const getPdfErrorMessage = (error: unknown): string => {
  if (error instanceof ApolloError) {
    const [graphQLError] = error.graphQLErrors;
    const message = graphQLError?.message;
    if (message === RATE_LIMIT_MESSAGE) {
      return "Too many downloads. Please try again later.";
    }
    if (message) {
      return message;
    }
  }
  return "Could not download the PDF. Please try again later.";
};

export const openPdfDownload = async (
  fetchPdf: () => Promise<PdfResult | null | undefined>,
  onError?: (message: string) => void
) => {
  const downloadWindow = window.open("", "_blank");
  if (downloadWindow) {
    downloadWindow.opener = null;
  }

  const result = await fetchPdf().catch((error: unknown) => {
    onError?.(getPdfErrorMessage(error));
    return null;
  });
  if (!result) {
    downloadWindow?.close();
    return;
  }

  const {data, filename} = result;
  const bytes = Uint8Array.from(atob(data), (char) => char.charCodeAt(0));
  const url = URL.createObjectURL(new Blob([bytes], {type: "application/pdf"}));
  if (downloadWindow && !downloadWindow.closed) {
    downloadWindow.location.href = url;
  } else {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  window.setTimeout(() => URL.revokeObjectURL(url), BLOB_URL_REVOKE_DELAY_MS);
};
